import { ENV_CONFIG } from '../../../../__config__/env';
import * as React from 'react';

import { Container } from '../../../layout/Container';
import { Heading } from '../../../ui/text/Heading';
import { Section } from '../../../layout/Section';
import { useFadeTransition } from '../../../../utils/hooks/useFadeTransition';
import styled from 'styled-components';
import { useParams } from 'react-router';

const CURRENT_YEAR = new Date().getFullYear();

const BASE_URL =
  `${ENV_CONFIG.CDN_HOST}privatmegleren`;

const TransparencyAct: React.FC = () => {
  const { fadeIn } = useFadeTransition({
    immidiate: true
  });

  const { urltag } = useParams<{ urltag: string }>();

  const isLatestReport =
    urltag === 'hovedkontor' || urltag === 'nyeboligeroslo';

  const [reportYear, setReportYear] = React.useState(
    isLatestReport ? CURRENT_YEAR : CURRENT_YEAR - 1
  );

  React.useEffect(() => {
    if (!isLatestReport) {
      return;
    }

    const checkFile = async () => {
      const latestFile = `aapenhetsloven_${CURRENT_YEAR}.pdf`;

      try {
        const response = await fetch(`${BASE_URL}/${latestFile}`, {
          method: 'HEAD'
        });

        if (!response.ok) {
          setReportYear(CURRENT_YEAR - 1);
        }
      } catch {
        setReportYear(CURRENT_YEAR - 1);
      }
    };

    void checkFile();
  }, [isLatestReport]);

  const fileName = `aapenhetsloven_${reportYear}.pdf`;
  const displayedFileName = `Redegjørelse Åpenhetsloven ${reportYear}.pdf`;
  const fileUrl = `${BASE_URL}/${fileName}`;

  return (
    <Container style={{ paddingTop: '100px', minHeight: '600px' }}>
      <Section style={fadeIn}>
        <TransparencyActWrapper>
          <Heading tag="h1" center>
            Åpenhetsloven
          </Heading>

          <a
            className="readMore"
            aria-label={`Last ned - ${displayedFileName}`}
            href={fileUrl}
            download
          >
            Last ned - {displayedFileName}
          </a>
        </TransparencyActWrapper>
      </Section>
    </Container>
  );
};

const TransparencyActWrapper = styled.div`
  .primary {
    color: ${({ theme }) => theme.colors.primary};
  }

  .bold {
    font-weight: 400;
  }

  .readMore {
    display: block;
    text-align: center;
  }
`;

export default TransparencyAct;
